import { useMemo } from 'react';
import { useTokenBalance } from "../../../state/wallet/hooks";
import { FixedPointNumber } from "../../../utils/fixedPoint";
import { useActiveOrdersOccupiedAmount } from "./useActiveOrdersOccupiedAmount";
export var useAvailableTokenBalance = (account, token) => {
  var balance = useTokenBalance(account, token);
  var activeOrdersOccupiedAmount = useActiveOrdersOccupiedAmount(token);
  return useMemo(() => {
    if (!balance) return new FixedPointNumber(0);
    var availableBalance = balance.minus(activeOrdersOccupiedAmount);
    return availableBalance.gt(0) ? new FixedPointNumber(availableBalance, token.decimals) : new FixedPointNumber(0);
  }, [token, balance, activeOrdersOccupiedAmount]);
};